(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-the-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.querySelector('[data-back-to-top]');

    if (!button || button.dataset.initialized === 'true') return;

    button.dataset.initialized = 'true';

    let lastScrollTop = Math.max(window.scrollY, 0);
    let ticking = false;

    const setVisibility = (visible) => {
      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', String(!visible));
      button.setAttribute('tabindex', visible ? '0' : '-1');
    };

    const updateButton = () => {
      const currentScroll = Math.max(window.scrollY, 0);
      const difference = currentScroll - lastScrollTop;

      if (currentScroll <= 200) {
        setVisibility(false);
      } else if (Math.abs(difference) > 5) {
        setVisibility(difference < 0);
        lastScrollTop = currentScroll;
      }

      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;

        ticking = true;
        window.requestAnimationFrame(updateButton);
      },
      { passive: true }
    );

    button.addEventListener('click', () => {
      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      window.scrollTo({
        top: 0,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
